import React, { useEffect, useState, Children, useContext } from 'react'
import { GlobalContext } from '../GlobalContext'
import { Link, useNavigate, useParams } from "react-router-dom"
import Button from '../formfields/Button'
import Modal from '../ui-elements/Modal'
import GuestUserLoginForm from '../auth/GuestUserLoginForm'

type Props = {
    orgMismatchDialog: string | null
    setOrgMismatchDialog: React.Dispatch<React.SetStateAction<any>>
}


function OrgMismatchDialog({
    orgMismatchDialog,
    setOrgMismatchDialog
}: Props) {

    const {
        tableData,
        userData,
        fridges,
        currentOrganisation,
        switchCurrentOrganisation,
        sendMessageToWebsocket,
        orgIdFromQrCode,
        handleLogout,
        t
    } = useContext(GlobalContext)

    const navigate = useNavigate()
    const { checklistId } = useParams()
    const [showForm, setShowForm] = useState(false)




    const currentOrgName = userData && currentOrganisation && JSON.parse(userData.organisationsForUser)[currentOrganisation] ? JSON.parse(userData.organisationsForUser)[currentOrganisation] : null

    const qrCodeOrgName = userData && currentOrganisation && JSON.parse(userData.organisationsForUser)[orgIdFromQrCode] ? JSON.parse(userData.organisationsForUser)[orgIdFromQrCode] : null

    const setMismatchedChecklistId = (checklistId: any) => {
        checklistId && window.localStorage.setItem('mismatchedChecklistId', checklistId)
    }


    return <Modal>
        <div className={`gap-4 flex flex-col items-center justify-center text-center`}>



            {qrCodeOrgName && currentOrgName ? <p>
                {t('SharedComponents.OrgMismatchDialog.mismatchWithName', { qrCodeOrgName, currentOrgName })}
            </p> :
                <p>
                    {t('SharedComponents.OrgMismatchDialog.mismatchNoName')}
                </p>}

            {!showForm && <div className={`w-full gap-2 flex flex-col items-center justify-center text-center`}>
                {orgMismatchDialog == 'switchOrgAsSameUser' && <Button
                    onClick={() => {
                        // reload in place instead of switchCurrentOrganisation's default '/' redirect
                        switchCurrentOrganisation(orgIdFromQrCode, false)
                        setOrgMismatchDialog(null)
                        window.location.reload()
                    }}
                    text={qrCodeOrgName ? 
                        t('SharedComponents.OrgMismatchDialog.switchToOrg', { qrCodeOrgName }) : 
                        t('SharedComponents.OrgMismatchDialog.switchAccount')}
                    variant={`primary`}
                // size={'big'}
                />}

                {orgMismatchDialog == 'switchOrgAsGuest' && <Button
                    onClick={() => {
                        setMismatchedChecklistId(checklistId)
                        setOrgMismatchDialog(null)
                        handleLogout()
                    }}
                    text={t('SharedComponents.OrgMismatchDialog.loginAsGuest')}
                    variant={`primary`}
                // size={'big'}
                />}

                {orgMismatchDialog == 'loginAsDifferentUser' && <Button
                    onClick={() => {
                        setMismatchedChecklistId(checklistId)
                        setOrgMismatchDialog(null)
                        handleLogout()
                    }}
                    text={t('SharedComponents.OrgMismatchDialog.loginAsNewUser')}
                    variant={`primary`}
                // size={'big'}
                />}

                <Button
                    onClick={() => {
                        navigate(`/`)
                        setOrgMismatchDialog(null)
                    }}
                    text={t('Buttons.cancel')}
                    variant={`gray`}
                // size={'big'}
                />
            </div>}

        </div>
    </Modal>
}

export default OrgMismatchDialog